import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout route for `/bookings/*` — same fix as `approvals.tsx` (see its
 * header comment): keeps `bookings.$id.tsx` a real child instead of this
 * file's content silently winning every `/bookings/*` URL. */
export const Route = createFileRoute('/bookings')({
  component: BookingsLayout,
});

function BookingsLayout() {
  return <Outlet />;
}
